module.exports = __webpack_public_path__ + "img/three3Green.76a8f9bd.jpg";